module.exports = __webpack_public_path__ + "static/media/answer2.56e563e8.png";